const ENV_PARAM = 'env';

export function getForwardedEnv(
  search: string = getCurrentSearch(),
): string | null {
  return new URLSearchParams(search).get(ENV_PARAM);
}

export function withForwardedEnv(
  url: string,
  search: string = getCurrentSearch(),
): string {
  const env = getForwardedEnv(search);

  if (!env) {
    return url;
  }

  const [urlWithoutFragment, fragment] = url.split('#', 2);
  const [path, query] = urlWithoutFragment.split('?', 2);
  const params = new URLSearchParams(query);
  params.set(ENV_PARAM, env);

  const urlWithEnv = `${path}?${params}`;
  return fragment ? `${urlWithEnv}#${fragment}` : urlWithEnv;
}

function getCurrentSearch(): string {
  return typeof window === 'undefined' ? '' : window.location.search;
}
